import * as React from 'react';
import {
	DefinitionList,
} from 'react-unity';
import { ContainerLayout, TextPassage, ColumnLayout, Column, TextLink, Badge, Well  } from '@emorg-prd/standard-react';
import moment from 'moment';
import WorkflowInstance from '../../../models/OnPremWorkflowInstance';
import WorkflowStateBadge from '../WorkflowStateBadge';
import { LinkTree, LinkTreeItem } from '../LinkTree';
import './WorkflowDetailWrapper.css';
import './OnPremWorkflowDetailWrapper.css';
import serviceNow from '../../../services/serviceNow.config';
import WorkflowHistoryModal from '../../OnPremPortOpeningRequests/components/WorkflowHistoryModal';
import { Section } from '../components/Section';
import { Button } from '../components/Button';
import { ProgressBar } from '../components/ProgressBar';
import { ContactApprovers, contactApproversLabel } from '../components/ContactApprovers';
import ApprovalContact from '../../../models/interfaces/ApprovalContact';

interface WorkflowDetailWrapperProps {
	title: string;
	loading?: boolean;
	workflowInstance?: WorkflowInstance;
	linkTree?: LinkTreeItem[];
	actions?: any;
	fromPOR?: boolean;
	fromDNDR?: boolean;
	currentApprovers?: ApprovalContact[];
	children?: any;
}

interface WorkflowDetailWrapperState {
	isHistoryModalVisible: boolean;
}

export default class WorkflowDetailWrapper extends React.Component<
	WorkflowDetailWrapperProps,
	WorkflowDetailWrapperState
> {
	constructor(props: WorkflowDetailWrapperProps) {
		super(props);
		this.state = {
			isHistoryModalVisible: false,
		};
		this.toggleHistoryModal = this.toggleHistoryModal.bind(this);
	}

	hasAvailableActions = (): boolean => {
		return !!this.props.actions && this.props.actions?.props?.children?.some((action) => !!action);
	};

	getTicketURL = (ticket: string) => {
		return ticket.toUpperCase().includes('CRQ')
			? `https://itconsole.na.xom.com/#/${ticket}`
			: `https://${serviceNow.serviceNowEnv}.service-now.com/nav_to.do?uri=${ticket.toUpperCase().includes('RITM') ? 'sc_req_item' : 'change_request'}.do?sysparm_query=number=${ticket}&sysparm_limit=1`;
	};

	wasCreatedByAnApp = () => {
		if (this.props.workflowInstance?.createdBy.id != this.props.workflowInstance?.owner.id) {
			return this.props.workflowInstance?.createdBy.email == null ? true : false;
		}
		return false;
	};

	renderContactApprovers = () =>
		this.props.currentApprovers?.length > 0 && (
			<DefinitionList.Item>
				<DefinitionList.Item.Key>{contactApproversLabel(this.props.currentApprovers)}</DefinitionList.Item.Key>
				<DefinitionList.Item.Value style={{ wordBreak: 'normal' }}>
					<ContactApprovers approvers={this.props.currentApprovers} />
				</DefinitionList.Item.Value>
			</DefinitionList.Item>
		);

	toggleHistoryModal() {
		this.setState((prevState) => ({
			isHistoryModalVisible: !prevState.isHistoryModalVisible,
		}));
	}

	render() {
		const currentState = this.props.workflowInstance?.currentWorkflowInstanceState;
		const workflowInstanceStates = this.props.workflowInstance?.onPremWorkflowInstanceStates || [];
		return (
			<ContainerLayout optionalClass="em-u-max-width-layout em-u-margin-top-double em-u-margin-bottom-double">
				{!this.props.loading && this.props.linkTree?.length > 0 && <LinkTree links={this.props.linkTree} />}
				<TextPassage>
					<h2 className="em-u-margin-top-double">
						{!this.props.loading ? (
							this.props.title
						) : (
							<ProgressBar indeterminate label="Loading data..." value={0} className="em-u-margin-top-half"/>
						)}
					</h2>
				</TextPassage>
				{!this.props.loading && (
					<ColumnLayout  type="em-l--two-column-wide">
						<Column type="main">
							{this.props.children}
						</Column>
						<Column type="secondary" optionalClass='secondary-column-style'>
							<Well optionalClass="border-color" type="em-c-well--bordered">
								{this.hasAvailableActions() && (
									<Section title="Actions" className="container-style container-action-style">
										{this.props.actions}
									</Section>
								)}
								<Section title="Request" className="container-style container-request-style">
									<DefinitionList>
										<div className="small-margin ">
											{!this.props.fromPOR ||
												(!this.props.fromDNDR && (
													<div className="small-margin">
														<DefinitionList.Item>
															<DefinitionList.Item.Key>
																Current Status
															</DefinitionList.Item.Key>
															<DefinitionList.Item.Value className="em-c-definition-list__vale_badge">
																<WorkflowStateBadge
																	workflowState={currentState.onPremWorkflowState}
																/>
															</DefinitionList.Item.Value>
														</DefinitionList.Item>
													</div>
												))}
											{this.wasCreatedByAnApp() ? (
												<div className="small-margin">
													{this.renderContactApprovers()}
													<DefinitionList.Item>
														<DefinitionList.Item.Key>
															<Badge
																text="Requested By an APP"
																type="em-c-badge--positive"
																optionalClass='em-u-margin-top'
															/>
														</DefinitionList.Item.Key>
														<DefinitionList.Item.Value></DefinitionList.Item.Value>
													</DefinitionList.Item>
													<DefinitionList.Item>
														<DefinitionList.Item.Key>Name</DefinitionList.Item.Key>
														<DefinitionList.Item.Value style={{ wordBreak: 'normal' }}>
															{this.props.workflowInstance?.createdBy.displayName}
														</DefinitionList.Item.Value>
													</DefinitionList.Item>
													<DefinitionList.Item>
														<DefinitionList.Item.Key>Id</DefinitionList.Item.Key>
														<DefinitionList.Item.Value style={{ wordBreak: 'normal' }}>
															{this.props.workflowInstance?.createdBy.id}
														</DefinitionList.Item.Value>
													</DefinitionList.Item>
													<DefinitionList.Item>
														<DefinitionList.Item.Key>
															Requested Date
														</DefinitionList.Item.Key>
														<DefinitionList.Item.Value>
															{moment(this.props.workflowInstance?.createdDate).format(
																'MMM DD, YYYY'
															)}
														</DefinitionList.Item.Value>
													</DefinitionList.Item>
												</div>
											) : (
												<div className="small-margin">
													{this.renderContactApprovers()}
													<DefinitionList.Item>
														<DefinitionList.Item.Key>Requested By</DefinitionList.Item.Key>
														<DefinitionList.Item.Value style={{ wordBreak: 'normal' }}>
															{this.props.workflowInstance?.createdBy.displayName}
														</DefinitionList.Item.Value>
													</DefinitionList.Item>
													<DefinitionList.Item>
														<DefinitionList.Item.Key>
															Requested Date
														</DefinitionList.Item.Key>
														<DefinitionList.Item.Value>
															{moment(this.props.workflowInstance?.createdDate).format(
																'MMM DD, YYYY'
															)}
														</DefinitionList.Item.Value>
													</DefinitionList.Item>
												</div>
											)}
											{this.props.workflowInstance?.currentWorkflowInstanceState.ticketId !==
												null && (
												<div className="small-margin">
													<DefinitionList.Item>
														<DefinitionList.Item.Key>Ticket #</DefinitionList.Item.Key>
														<DefinitionList.Item.Value className="em-c-definition-list__value_ticket">
															<TextLink
																target="_blank"
																url={this.getTicketURL(
																	this.props.workflowInstance
																		?.currentWorkflowInstanceState.ticketId)}
																optionalClass="em-u-display-inline"
															>
																{
																	this.props.workflowInstance
																		?.currentWorkflowInstanceState.ticketId
																}
																&nbsp;
															</TextLink>
														</DefinitionList.Item.Value>
													</DefinitionList.Item>
												</div>
											)}
										</div>
									</DefinitionList>
									<Button
										variant="secondary"
										isLoading={false}
										disabled={false}
										name="View Workflow History"
										loadingVariant="tertiary"
										optionalClass="em-u-margin-left"
										onClick={this.toggleHistoryModal}
									>
										<span><strong>View Workflow History</strong>&nbsp;</span>
									</Button>
								</Section>
								{!!currentState.performedReason && (
									<Section title="Last Comment" className="container-style container-comment-style">
										<p>{currentState.performedReason}</p>
										<small>
											<i>
												{currentState.performedByUser.displayName},{' '}
												{moment(currentState.performedOnDate).format('MM/DD/YYYY')}
											</i>
										</small>
									</Section>
								)}
							</Well>
						</Column>
					</ColumnLayout>
				)}
				<WorkflowHistoryModal
					visible={this.state.isHistoryModalVisible}
					onClose={this.toggleHistoryModal}
					workflowInstanceStates={workflowInstanceStates}
				/>
			</ContainerLayout>
		);
	}
}
